import "../../../resources/less/Family/ThemePages/EraOfDragons.less";
import BaseThematique from "./BaseThematique";

class EraOfDragons extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new EraOfDragons();
});
